var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tabbar"}},[_c('ul',_vm._l((_vm.tabbar),function(item,index){return _c('li',{key:index,class:_vm.tabbarIndex==index?'on':'',on:{"click":function($event){return _vm.changeRouter(item.router)}}},[_c('div',[_c('img',{attrs:{"src":item.icon,"alt":""}})]),_c('p',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }